import { Products } from "../modules/products";

export const ProductsPage = () => {
  return <Products />;
};
